export default __webpack_public_path__ + "static/media/tagme3.01a6c570.jpg";